import React from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import DoneIcon from '@mui/icons-material/Done';
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Collapse,
  Typography,
} from '@mui/material';
import { styled } from '@mui/system';

import { useOnClickOutside } from '../../../../common/hooks/UseOnClickedOutside';

export const LetterSendConfirmation = ({
  onClose,
  onSendManually,
  onSend,
  show,
}: {
  onSend: () => void;
  onSendManually: () => void;
  onClose: () => void;
  show: boolean;
}) => {
  const containerRef = React.createRef<HTMLDivElement>();
  useOnClickOutside(containerRef, onClose);

  return (
    <Collapse in={show}>
      <div ref={containerRef}>
        <RootCard>
          <CardActionArea>
            <CardContent>
              <Typography variant="h5" component="h2">
                Send Letter To Applicant
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Clicking YES will trigger an email to the applicant. Confirm?
              </Typography>
              <Box marginTop={2}>
                <YesButton
                  variant="contained"
                  color="primary"
                  startIcon={<DoneIcon />}
                  onClick={onSend}
                >
                  Yes
                </YesButton>
                <SendManuallyButton
                  variant="contained"
                  color="primary"
                  onClick={onSendManually}
                >
                  Send Manually
                </SendManuallyButton>
                <CancelButton
                  variant="contained"
                  color="primary"
                  startIcon={<ClearIcon />}
                  onClick={onClose}
                >
                  Cancel
                </CancelButton>
              </Box>
            </CardContent>
          </CardActionArea>
        </RootCard>
      </div>
    </Collapse>
  );
};

const RootCard = styled(Card)(() => ({
  backgroundColor: '#F4F5F7',
  marginRight: '17%',
}));

const YesButton = styled(Button)(({ theme }) => ({
  marginRight: theme.spacing(2),
}));

const SendManuallyButton = styled(Button)(({ theme }) => ({
  marginRight: theme.spacing(2),
  backgroundColor: '#d09500',
}));

const CancelButton = styled(Button)(() => ({
  backgroundColor: '#FF3B30',
  float: 'right',
}));
